import React from 'react';
import ParticipantInfo from '../ParticipantInfo/ParticipantInfo';
import ParticipantTracks from '../ParticipantTracks/ParticipantTracks';
export default function Participant({ participant, name, disableAudio, phoneParticipant, onClick, isSelected, menu, videoPriority, }) {
    return (React.createElement(ParticipantInfo, { participant: participant, phoneParticipant: phoneParticipant, name: name, menu: menu, onClick: onClick, isSelected: isSelected },
        React.createElement(ParticipantTracks, { participant: participant, phoneParticipant: phoneParticipant, disableAudio: disableAudio, videoPriority: videoPriority })));
}
//# sourceMappingURL=Participant.js.map